import Glide from "@glidejs/glide"
import Debounce from "lodash.debounce"

const elementary = require('../vendor/elementary.js');

// const bp  = 1100;
const bp  = 720;
const bps = [
	{
		min: 720,
		max: 999,
		showNum: 3
	},
	{
		min: 1000,
		max: 1499,
		showNum: 4
	},
	{
		min: 1500,
		max: 1699,
		showNum: 5
	},
	{
		min: 1700,
		showNum: 7
	}
];
const selector = '[data-carousel]'

let els               = null;
let carouselInstances = [];

function Carousel() {

	// Search for carousel elements on page
	els = document.querySelectorAll(selector);
	
	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// Add resize event listener to window
	window.addEventListener('resize', Debounce(checkWindowWidth, 500));
	checkWindowWidth();
}

const changeArrowDisabledStatus = (arrowEl, disableIt) => {
	if (arrowEl !== null) {

		if (disableIt) {
			arrowEl.setAttribute('disabled', true);
		} else {
			arrowEl.removeAttribute('disabled');
		}
	}
}
const disablePrevArrow = (parent) => {
	changeArrowDisabledStatus(parent.querySelector('[data-glide-dir="<"]'), true);
}
const enablePrevArrow = (parent) => {
	changeArrowDisabledStatus(parent.querySelector('[data-glide-dir="<"]'), false);
}
const disableNextArrow = (parent) => {
	changeArrowDisabledStatus(parent.querySelector('[data-glide-dir=">"]'), true);
}
const enableNextArrow = (parent) => {
	changeArrowDisabledStatus(parent.querySelector('[data-glide-dir=">"]'), false);
}

const checkWindowWidth = () => {

	const ww    = window.innerWidth;
	const bpObj = bps.find( (item) => {
		return (ww >= item.min && ww <= item.max)
	});

	// If window wider than min breakpoint and carousel not yet created...
	// if (window.innerWidth >= bps[0].min) {
	if (window.innerWidth >= bp) {

		// If there are not yet any carousels...
		if (carouselInstances.length === 0) {

			// For each found element...
			[].forEach.call(els, function(item) {

				let g = null;
				
				// Get id of carousel
				const carouselId = item.dataset.carousel;

				g = new Glide('[data-carousel="' + carouselId + '"]', {
					type: 'slider',
					perView: 3,
					gap: 40,
					rewind: false,
					breakpoints: {
						1099: {
							perView: 2
						}
					}
				});
				g.on('mount.after', function() {
					elementary(); // Run elementary after carousel mounted, in case contents use element queries

					// Disable back arrow when carousel first mounted
					disablePrevArrow(item);

					const mountedEvent = new Event("carousel-mounted", {
						bubbles: true
					});
					item.dispatchEvent(mountedEvent);
				});
				g.on('run', function(e) {
					console.log(g);

					// Disable prev arrow when at start
					if (g.index == 0) {
						disablePrevArrow(item);
					} else {
						enablePrevArrow(item);
					}

					// Disable next arrow when at end
					if ((g.index + g.settings.perView) >= parseInt(item.dataset.carouselNumSlides)) {
						disableNextArrow(item);
					} else {
						enableNextArrow(item);
					}
				});

				g.mount();

				// ... create carousel
				carouselInstances.push(g);
			});
		}		
		
	} else {

		// If there are any carousels...
		if (carouselInstances.length > 0) {

			// ...destroy each
			for (let item of carouselInstances) {
				item.destroy();
			}

			carouselInstances = [];
		}
	}

}

export default Carousel;